// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"40a98846","116":"09b92b88","150":"b9527735","292":"95d01056","298":"a51b7cf4","345":"a0f8a8cd","453":"bd78d9cd","916":"2a73efc6"}[chunkId] + ".chunk.js";
};